import React from 'react';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';

const navigationContext = {
  nav: (x: number, y: number, href: string, router: AppRouterInstance) => {
    const page = document.getElementById('page');
    const loadingBubble = document.getElementById('loading-bubble');

    const w = window.screen.availWidth;
    const h = window.screen.availHeight;

    const dtl = Math.sqrt((x - 0) * (x - 0) + (y - 0) * (y - 0));
    const dtr = Math.sqrt((x - w) * (x - w) + (y - 0) * (y - 0));
    const dbr = Math.sqrt((x - w) * (x - w) + (y - h) * (y - h));
    const dbl = Math.sqrt((x - 0) * (x - 0) + (y - h) * (y - h));
    const size = 2 * Math.max(dtl, dtr, dbr, dbl);

    if (loadingBubble) {
      loadingBubble.style.left = `${x}px`;
      loadingBubble.style.top = `${y}px`;
      loadingBubble.style.width = `${size}px`;
      loadingBubble.style.height = `${size}px`;
      loadingBubble.classList.add('active');
    }

    document.documentElement.classList.add('loading', 'in');

    setTimeout(() => {
      router.push(href);
      if (page) {
        page.style.clipPath = `ellipse(100vw 0 at 50vw 0)`;
      }
    }, 600);
  },
  hideLoadingScreen: () => {
    const page = document.getElementById('page');

    document.documentElement.classList.remove('in');
    document.documentElement.classList.add('out');

    if (page) {
      page.style.clipPath = `ellipse(100vw 250vh at 50vw 0)`;
    }

    setTimeout(() => {
      if (page) {
        page.style.clipPath = '';
      }
      document.documentElement.classList.remove('loading', 'out');
    }, 600);
  },
};

export const NavigationContext = React.createContext(navigationContext);
